import { render } from "./your-profile-form-component.vue?vue&type=template&id=33ac7cfb"
import script from "./your-profile-form-component.vue?vue&type=script&lang=js"
export * from "./your-profile-form-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__